module.exports = __webpack_public_path__ + "img/perfectiondetail.1149d95.jpg";